export default "__VITE_ASSET__$WkRiPVJ__"